import { inject, Injectable } from '@angular/core';
import {
    OtherSalesEndpoints,
    ParkingAndOtherSalesCommissionEndpoints,
} from 'app/core/enums/endpoints';
import { DeleteSaleBody } from 'app/core/interfaces/finances';
import { ApiService } from 'app/services/api/api.service';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class OtherSalesService {
    private _endpoint = OtherSalesEndpoints;
    private _commissionEndps = ParkingAndOtherSalesCommissionEndpoints;
    private _apiService = inject(ApiService);

    constructor() {}

    // --------------------------------------------------------------------------
    // @ Public methods
    // --------------------------------------------------------------------------
    // --------------------------------------------------------------------------
    // @ CRUD methods
    // --------------------------------------------------------------------------

    getAll(playdateId: number, locationId?: number): Observable<any> {
        return this._apiService.getOne(this._endpoint.getAll, playdateId);
    }

    // getOne(id: number): Observable<any> {
    //     return this._apiService.getOne(this._endpoint.getOne, id);
    // }

    create(otherSaleData: any): Observable<any> {
        return this._apiService.post(this._endpoint.create, otherSaleData);
    }

    update(otherSaleData: string, id: number): Observable<any> {
        return this._apiService.update(
            this._endpoint.update,
            otherSaleData,
            id
        );
    }

    delete(data: DeleteSaleBody): Observable<any> {
        return this._apiService.deleteWithParam(this._endpoint.delete, data);
    }

    /**
     * @description
     * Get others sales commissions
     * @returns
     */
    getCommissions(playdateId: number): Observable<any> {
        return this._apiService.getOneWithQueryParams(
            this._commissionEndps.getAll,
            playdateId,
            {
                play_date_id: playdateId,
                departure: 'Other',
            }
        );
    }
}
